<template>
  <v-snackbar
    v-model="SnackBarComponent.SnackbarVmodel"
    :color="SnackBarComponent.SnackbarColor"
    location="top center"
    :timeout="SnackBarComponent.timeout"
  >
    <div class="text-center">{{ SnackBarComponent.SnackbarText }}</div>
  </v-snackbar>
</template>

<script setup>
defineProps({
  SnackBarComponent: Object
})
</script>

<style scoped>
/* If you need custom styling for top center positioning */
:deep(.v-snackbar) {
  justify-content: center;
}
</style>